// extracted by mini-css-extract-plugin
export default {"root":"RefinementDisclosuresModal_root__UWLjZ","modalContainer":"RefinementDisclosuresModal_modalContainer__37g37"};